import React, { Component } from 'react';
import GridAddButton from '../GridAddButton'
import TwoVertSectionsView from './TwoVertSectionsView';
import GridButton from '../GridButton';

class TwoVertsSectionGridView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderGridItem = (data) => {
        const { title, icon } = data;
        return <GridButton title={title} icon={icon}></GridButton>
    }

    render() {
        const { onCreateClicked = () => { }, data = [] } = this.props;

        const gridItems = data.map((d, index) => {
            return this.renderGridItem(d);
        })

        return (
            <TwoVertSectionsView
                leftChildren={<GridAddButton onClick={onCreateClicked}></GridAddButton>}
                rightChildren={gridItems}>
            </TwoVertSectionsView>
        );
    }
}

export default TwoVertsSectionGridView;